module.exports = __webpack_public_path__ + "static/img/image_placeholder.6e3610d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/kaprow/images/image_placeholder.jpg
// module id = HprN
// module chunks = 0